import { Box, Button, Card, CardContent, Grid, makeStyles, TextField, Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { challengeActions } from '../../actions';
import { BackNavAdmin, BackNavAdminButtons, BackNavAdminMenus, ChallengeInfoAwardsCard } from '../../components';
import { ReactComponent as MedalIcon } from '../../assets/imgs/worskpace-premium-icon.svg'
import { Autocomplete } from '@material-ui/lab';

const useStyle = makeStyles(theme => ({
    contentContainer: {
        marginTop: 32,
        display: 'flex',
        justifyContent: 'center'
    },
    cardContainer: {
        padding: 30
    },
    topColocation: {
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        marginTop: 32,
        maxWidth: 744
    },
    colocation: {
        fontWeight: 600,
        fontSize: 16,
    },
    ideaSelect: {
        backgroundColor: theme.palette.neutrals.high.light,
        width: 596,
    },
    boxIcon: {
        width: 40,
        height: 40,
        borderRadius: '6rem',
        backgroundColor: theme.palette.primary.light,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    icon: {
        fill: theme.palette.primary.main,
    },
    title: {
        color: theme.palette.neutrals.low.dark,
        fontWeight: 600,
        fontSize: 20,
        marginLeft: 16
    },
    inputLabel: {
        textTransform: 'lowercase'
    },
    rankSection: {
        maxWidth: 840
    },
    rewardSection: {
        maxWidth: 422
    },
    sendButton: {
        maxWidth: 705,
        display: 'flex',
        justifyContent: 'end',
        marginTop: 45
    }
}));

function RewardChallenge() {
    const dispatch = useDispatch();
    const { id } = useParams();
    const { challengeDetail,
        challengeDetail: { rewards },
        challengeTableIdeas: { ideas, paging }, winners } = useSelector((state) => state.challenge);
    const { typeProfile: { type } } = useSelector((state) => state.user);
    const { t } = useTranslation();
    const classes = useStyle();

    useEffect(() => {
        !!rewards?.length && rewards.forEach(({ index, win }) => dispatch(
            challengeActions.setWinners({ index, idea: win })
        ));
    }, [rewards]);

    useEffect(() => {
        dispatch(challengeActions.getChallengeById(id));
        dispatch(
            challengeActions.getIdeasChallenge(
                id,
                1,
                paging.sort,
                paging.limit,
                paging.statusCode
            )
        );
    }, [dispatch, id]);

    function handleSendWinners() {
        if (winners.length > 0) {
            dispatch(challengeActions.postWinners(winners))
        }
    };

    function handleSelectWinners(index, id) {
        if (index !== null && id !== null) {
            const idea = ideas.find(idea => idea._id === id);
            dispatch(challengeActions.setWinners({ index, idea }))
        };
    };

    function handleSelectDefaultValue(index) {
        if (rewards[index].win) {
            const { userName, name, _id } = rewards[index].win;
            return { userName, name, _id };
        }
        return null
    };

    function clearSelectWinner(index) {
        dispatch(challengeActions.clearSelectWinner(index));
    };
    const shouldAbleSendButton = winners?.length === rewards?.length;

    return (<>
        <BackNavAdmin title={challengeDetail.name} pathname="/challenges">
            <BackNavAdminButtons type={type} id={id} />
        </BackNavAdmin>
        <BackNavAdminMenus type={type} id={id} />
        <Grid container spacing={3} className={classes.contentContainer}>
            <Grid className={classes.rankSection} item xs={12} lg={8}>
                <Card className={classes.cardContainer}>
                    <CardContent>
                        <Box display='flex' alignItems='center'>
                            <Box className={classes.boxIcon}>
                                <MedalIcon className={classes.icon} />
                            </Box>
                            <Typography className={classes.title}>{t('ideias_premiadas')}</Typography>
                        </Box>
                        {rewards && rewards.length > 0 && rewards.map((_award, index) => (
                            <Box key={index} className={classes.topColocation}>
                                <Typography className={classes.colocation}>{index + 1}° {t('lugar')}</Typography>
                                <Autocomplete
                                    id={`autoComplete${index}`}
                                    defaultValue={handleSelectDefaultValue(index)}
                                    sx={{ width: 300 }}
                                    className={classes.ideaSelect}
                                    options={ideas.map(({ user, name, _id }) => ({ userName: user.name, name, _id }))}
                                    getOptionLabel={(option) => `${option.name} - ${option.userName}`}
                                    onChange={(_e, newValue) => newValue !== null ? handleSelectWinners(index, newValue._id) : clearSelectWinner(index)}
                                    renderInput={(params) => <TextField {...params} placeholder={t('selecione_a_ideia_premiada')} label={t('ideias').toLowerCase()} variant="filled" name={index} />}
                                />
                            </Box>
                        ))}
                        <Box className={classes.sendButton}>
                            <Button disabled={!shouldAbleSendButton} onClick={handleSendWinners} variant="contained" color="primary">
                                {t('salvar_selecao')}
                            </Button>
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
            <Grid className={classes.rewardSection} item xs={12} lg={4}>
                <ChallengeInfoAwardsCard challenge={challengeDetail} />
            </Grid>
        </Grid>
    </>);
};

export { RewardChallenge };